// When an SOS must make noise — pure, so the rules are tested, not eyeballed.
//
// Leon's production audit (2026-10-23): an SOS was visual only, so an operator
// on another tab, or looking away, never heard it. The alarm rings while ANY
// open SOS is still unacknowledged, and stops the moment someone takes it
// (acknowledgedAt set — by anyone, on any screen). A browser notification
// fires once per new SOS, so a backgrounded tab still surfaces it.

import type { SosAlertView } from "./sos.model";

/** How often the alarm repeats while an SOS is waiting for someone. */
export const SOS_ALARM_EVERY_MS = 4_000;

export function hasUnacknowledged(alerts: readonly SosAlertView[]): boolean {
  return alerts.some((alert) => alert.acknowledgedAt === null);
}

/** Unacknowledged alerts not announced yet — each gets one notification. */
export function newUnacknowledged(
  alerts: readonly SosAlertView[],
  announced: ReadonlySet<string>,
): SosAlertView[] {
  return alerts.filter((alert) => alert.acknowledgedAt === null && !announced.has(alert.id));
}

/** The notification's words: who, how serious, where — never a client. */
export function sosNotificationText(alert: SosAlertView): { title: string; body: string } {
  return {
    title: `SOS — ${alert.therapistName}`,
    body: [alert.dangerLabel, alert.hubName ? `${alert.hubName} hub` : null, alert.ref]
      .filter(Boolean)
      .join(" · "),
  };
}
